<template>
    <v-app class="home" style="overflow: hidden;">
        <!-- <MenuLayout/> -->
        <router-view />
    </v-app>
</template>
<script>
import { sync } from 'vuex-pathify'
// import MenuLayout from '@/views/MenuLayout'
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.VUE_APP_CENTRIFUGE_URL)
export default {
    name: "HomeView",
    components: {
        // MenuLayout
    },
    computed: {
        ...sync('*')
    },
    data() {
        return {
            tab: null,
            text: 'test',
            data_user: {}
        }
    },
    created() {
        // console.log('layout')
        this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
        // this.$i18n.locale = 'th'
        // console.log(this.$i18n.locale)
        // console.log(window.navigator.javaEnabled())
        // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
          user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
          user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
        // connect socket
        this.$socket.emit('join', {
            room: this.data_user.tokenuser,
            type: 'web'
        })
        // connection centrifuge
        var me = this
        var events = ''
        var data_msg = ''
        centrifuge.setToken(process.env.VUE_APP_CENTRIFUGE_KEY);
        centrifuge.subscribe(me.data_user.tokenuser, function(message) {
            // console.log(message)
            events = message.data.event
            data_msg = message.data.data
            console.log(`centrifuge: ${events}`)
          if (events === 'message') {
            if (data_msg.last_tokenmessage !== undefined) {
              // event unsend
              me.socket_unsendmessage = data_msg
            } else {
              // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
              if (data_msg.typeofmessage === 'official_template' || data_msg.typeofmessage === 'system' || data_msg.typeofmessage === 'system_action_albums') {
                me.axios.post(process.env.VUE_APP_API_alpine + '/v3/getmessage', {tokenmessage: data_msg.tokenmessage, tokenuser: me.token}).then((response) => {
                  me.socketmessage = response.data.source
                })
              } else {
                // event message
                me.socketmessage = data_msg
              }
              // console.log(me.socketmessage)
              // if (data_msg.option !== undefined) {
              //     me.typeAgoraCall = data_msg.option
              // }
            }
            if (me.socketmessage.tokenroom !== me.$route.params.roomid && me.socketmessage.tokenuser !== me.token) {
              if (me.socketmessage.typeofmessage !== 'message') {
                // me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
              } else {
                // can't use this.convertMention
                // me.noti_msg(me.socketmessage.nickname, 'Message:  '  + ((me.socketmessage.message).replace(/\<tax>/g,'@')).replace(/<\/tax>/g,''), me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
              }
            }
          } else if (events === 'disable_quick_reply') {
            me.socketdisablequickreply = data_msg
          } else if (events === 'update-agora') {
            me.socket_update_agora = data_msg
          } else if (events === 'accept_call') {
            me.socket_accept_call = data_msg
          } else if (events === 'service_call_agora') {
            // keep type option agora call
            if (process.env.NODE_ENV === 'development') {
              // ถ้ายังไม่ได้กดเข้าห้องแชทแต่มันการ call
              // if (me.$router.currentRoute.path === '/mobile/homepage') {
                // call agora
                setTimeout(function() {
                  var infor = {
                    agora_token: data_msg.agora_token,
                    channel: data_msg.channel,
                    nickname: data_msg.nickname,
                    option: data_msg.option,
                    picture: data_msg.picture,
                    tokenroom: data_msg.tokenroom,
                    one_id: me.one_id
                  }
                  me.infor_call = infor
                  me.AgoraOption = data_msg.option
                  me.AgoraCallDialog = true
                  // console.log(me.AgoraCallDialog)
                  // console.log(me.infor_call)
                }, 1000);
              // } else {
                // me.typeAgoraCall = data_msg
              // }
              // console.log(me.typeAgoraCall)
            }
          } else if (events === 'message_read') {
            // console.log('message_read')
          } else if (events === 'disable_approve') {
            me.socketdisableapprove = data_msg
          } else if (events === 'quick_reply') {
            me.socketquickreply = data_msg
            // console.log(me.socketquickreply)
          } else if (events === 'close_webview') {
            me.socket_close_webview = data_msg
          } else if (events === 'switch_keyboard') {
            me.socket_switch_keyboard = data_msg
            // console.log(me.socket_switch_keyboard)
          } else if (events === 'switch_richmenu') {
            me.socket_switch_richmenu = data_msg
            // console.log(me.socket_switch_richmenu)
          } else if (events === 'disable_official_template') {
            me.socket_official_template = data_msg
          } else if (events === 'drop_menu') {
            me.socket_drop_menu = data_msg
          } else if (events === 'consent') {
            // me.consentOnechatDialog = false
            me.centrifuge_consent = data_msg
          }
        })
        centrifuge.on('connect', function() {
            console.log("connected centrifuge");
        });
        centrifuge.on('disconnect', function() {
            console.log("disconnected centrifuge");
        });
        centrifuge.connect();
    },
    sockets: {
        connect() {
            console.log('socket connected')
            this.$socket.emit('join', {
                room: this.data_user.tokenuser,
                type: 'web'
            })
        },
        disconnect: function() {
            console.log('socket disconnect')
        },
        message (data) {
          // console.log("socket message =>", data);
          if (data.hasOwnProperty('tokenuser')) {
            this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v3/getmessage', {tokenmessage: data.tokenmessage, tokenuser: this.token}).then((response) => {
              if (response.data.source.typeofmessage === 'albums_message') {
                this.socketmessage = response.data.source.typeofmessage === 'albums_message' && (response.data.source.message === 'create_albums' || response.data.source.message === 'addimage_albums') ? response.data.source : null
              } else if (response.data.source.typeofmessage === 'note') {
                this.socketmessage = response.data.source
              } else if (response.data.source.typeofmessage === 'video') {
                this.socketmessage = response.data.source
              }
            })
          }
        },
        event_friend(data) {
            this.socketfriend = data
        },
        event_accept_friend(data) {
            this.socketaccept_friend = data
        },
        event_remove_request_friend(data) {
            // console.log('event_remove_request_friend')
            this.socketremove_request_friend = data
        },
        event_remove_friend(data) {
            // console.log('event_remove_friend')
            this.socketremove_friend = data
        },
        event_create_group(data) {
            // console.log(data)
            this.socketcreate_group = data
        },
        event_invite_group(data) {
            this.socketinvite_group = data
        },
        event_active_group(data) {
            this.socketactive_group = data
        },
        event_cancel_group(data) {
            // console.log('event_cancel_group')
            this.socketcencel_group = data
        },
        event_leave_group(data) {
            // console.log('event_leave_group')
            this.socketleave_group = data
        },
        event_kick_group(data) {
            // console.log('event_kick_group')
            this.socket_kickmember = data
        },
        event_note (data) {
          // console.log('event_note')
          // console.log(data)
          this.socketnote = data
        },
    }
}
</script>
